import RadioTile from '@ramsey-design-system/radio-tile';
import { Field, useFormikContext } from 'formik';
import { CoverageCheckupState } from '../../../store/step';
import { FormikFormMultiField } from '../../shared/FormikFormMultiField';
import React, { ReactElement } from 'react';

interface DisabilityInsuranceTypeStepFormProps {
  name: keyof CoverageCheckupState;
}

function DisabilityInsuranceTypeStepForm({
  name,
}: DisabilityInsuranceTypeStepFormProps): ReactElement {
  const { values } = useFormikContext<CoverageCheckupState>();
  return (
    <FormikFormMultiField<CoverageCheckupState> name={name} as="fieldset">
      <Field
        className="mb-1.5 max-w-[300px]"
        as={RadioTile}
        name={name}
        label="Long-term"
        value="long_term"
        data-testid="long_term"
        checked={values[name] === 'long_term'}
        size="sm"
      />
      <Field
        className="mb-1.5 max-w-[300px]"
        as={RadioTile}
        name={name}
        label="Short-term"
        value="short_term"
        data-testid="short_term"
        checked={values[name] === 'short_term'}
        size="sm"
      />
      <Field
        className="mb-1.5 max-w-[300px]"
        as={RadioTile}
        name={name}
        label="Both short-term and long-term"
        value="both"
        data-testid="both"
        checked={values[name] === 'both'}
        size="sm"
      />
      <Field
        className="mb-1.5 max-w-[300px]"
        as={RadioTile}
        name={name}
        label="I'm not sure"
        value="not_sure"
        data-testid="not_sure"
        checked={values[name] === 'not_sure'}
        size="sm"
      />
    </FormikFormMultiField>
  );
}

export { DisabilityInsuranceTypeStepForm };
